import { d as o, _ as t } from "./_plugin-vue_export-helper-8568c831.mjs";
import { openBlock as s, createElementBlock as r, normalizeClass as n, normalizeStyle as l, createElementVNode as a } from "vue";
const c = o("arrow-down2"), i = /* @__PURE__ */ a("path", {
  d: "M1741.19 227.497a121.654 121.654 0 1 1 127.858 206.812L1292.65 790.27a182.482 182.482 0 0 1-191.727 0L524.646 434.31a121.654 121.654 0 1 1 127.859-206.812l544.403 335.887c181.387-111.8 362.773-223.965 544.282-335.887",
  fill: "currentColor",
  "fill-opacity": "0.9"
}, null, -1), p = [
  i
];
function d(e, m, _, f, w, u) {
  return s(), r("svg", {
    class: n(e.classes),
    style: l(e.style),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2472 1024",
    role: "presentation"
  }, p, 6);
}
const v = /* @__PURE__ */ t(c, [["render", d]]);
export {
  v as default
};
